"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeByKey = exports.updateBillingAddress = exports.toggle = exports.payload = exports.update = void 0;
const ramda_1 = require("ramda");
const update = (propertyName) => (state, property) => (Object.assign(Object.assign({}, state), { [propertyName]: property }));
exports.update = update;
exports.payload = (0, ramda_1.nthArg)(1);
const toggle = (property) => !property;
exports.toggle = toggle;
const updateBillingAddress = (propertyName) => (state, property) => (Object.assign(Object.assign({}, state), { billingAddress: Object.assign(Object.assign({}, state.billingAddress), { [propertyName]: property }) }));
exports.updateBillingAddress = updateBillingAddress;
const mergeByKey = (key) => (_, prop) => (0, ramda_1.mergeDeepRight)(_, { [key]: prop });
exports.mergeByKey = mergeByKey;
//# sourceMappingURL=stateHelpers.js.map